/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：ローディングサービス
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */
import { Loading } from 'element-ui'
import { ElLoadingComponent } from 'element-ui/types/loading'

/**
 * ローディングサービス
 *
 * @class
 */
class LoadingService {
  /**
   * ローディングウィンドウ
   */
  private loadingWindow?: ElLoadingComponent
  /**
   * 開いた回数
   */
  private count = 0
  /**
   * 自動閉じるタスク
   */
  private autoCloseTask = -1

  /**
   * ローディングウィンドウを開く。
   *
   * @param {string} text 表示される文言
   * @returns {void}
   */
  open(text = ''): void {
    if (this.count < 0) {
      this.count = 0
    }

    this.count++
    if (this.loadingWindow) {
      return
    }

    this.loadingWindow = Loading.service({
      fullscreen: true,
      lock: true,
      body: true,
      customClass: 'app-loading',
      text: text
    })

    if (this.autoCloseTask !== -1) {
      clearTimeout(this.autoCloseTask)
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.autoCloseTask = setTimeout(() => {
      this.count = 1
      this.close()
    }, 3 * 60 * 1000)
  }

  /**
   * ローディングウィンドウを閉じる。
   *
   * @returns {void}
   */
  close(): void {
    if (!this.loadingWindow) {
      return
    }

    this.count--
    if (this.count > 0) {
      return
    }

    if (this.autoCloseTask !== -1) {
      clearTimeout(this.autoCloseTask)
    }

    this.loadingWindow.close()
    this.loadingWindow = undefined
    this.count = 0
    this.autoCloseTask = -1
  }
}

export const loadingService = new LoadingService()
